/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Draggable = void 0;
var _round = _interopRequireDefault(require("lodash/round"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable class-methods-use-this */
var MIN_DRAG_DISTANCE = 5;
var INERTIA_MIN = 2;
var INERTIA_MAX = 50;
var FRICTION = 1.3;
var captureClick = function captureClick(e) {
  e.stopPropagation();
  e.target.removeEventListener('click', captureClick, {
    capture: true
  });
};
var preventDefault = function preventDefault(e) {
  return e.preventDefault();
};
var Draggable = /*#__PURE__*/function () {
  function Draggable(_ref) {
    var _this = this;
    var _target = _ref.target,
      onMoveTo = _ref.onMoveTo,
      initialCoords = _ref.initialCoords,
      horizontalGridRatio = _ref.horizontalGridRatio;
    _classCallCheck(this, Draggable);
    _defineProperty(this, "isDown", false);
    _defineProperty(this, "isDragging", false);
    _defineProperty(this, "initialCoords", void 0);
    _defineProperty(this, "initialScrollTop", void 0);
    _defineProperty(this, "offsetCoords", void 0);
    _defineProperty(this, "startX", void 0);
    _defineProperty(this, "startY", void 0);
    _defineProperty(this, "horizontalTarget", void 0);
    _defineProperty(this, "onMouseDown", function (e) {
      if (_this.isDown) {
        // prevent double (mouse & touch) trigger on mobile
        return;
      }
      var _e$touches = e.touches,
        touches = _e$touches === void 0 ? [] : _e$touches,
        type = e.type;
      var _ref2 = touches.length ? touches[0] : e,
        clientY = _ref2.clientY,
        pageX = _ref2.pageX,
        target = _ref2.target;
      _this.isTouch = type === 'touchstart';
      _this.inertiaY = 0;
      _this.startTarget = target;
      _this.initialCoords = _this.offsetCoords;
      _this.requestedCoordinates = {
        x: _this.initialCoords.x,
        y: _this.initialScrollTop
      };
      _this.isDown = true;
      _this.isDragging = false;
      _this.startX = pageX;
      _this.startY = clientY;
      _this.initialScrollTop = document.documentElement.scrollTop;
      _this.animationFrameRequested = false;
    });
    _defineProperty(this, "startDragging", function () {
      _this.isDragging = true;
    });
    _defineProperty(this, "reachedDragThreshold", function (moveX, moveY) {
      return Math.hypot(moveX, moveY) > MIN_DRAG_DISTANCE;
    });
    _defineProperty(this, "onMouseMove", function (e) {
      if (!_this.isDown) {
        return;
      }
      var _e$touches2 = e.touches,
        touches = _e$touches2 === void 0 ? [] : _e$touches2;
      var _ref3 = touches.length ? touches[0] : e,
        clientX = _ref3.clientX,
        clientY = _ref3.clientY,
        pageX = _ref3.pageX;
      var moveY = clientY - _this.startY;
      var moveX = clientX - _this.startX;
      if (!_this.isDragging) {
        if (_this.reachedDragThreshold(moveX, moveY)) {
          _this.startDragging();
        } else {
          // disregard small mouse movements during regular clicks
          return;
        }
      }

      // throttle updates by rounding up positions
      var newX = _this.initialCoords.x - (pageX - _this.startX) * _this.horizontalGridRatio;
      var roundedX = (0, _round["default"])(newX, 3);
      var newY = _this.initialScrollTop - moveY;
      _this.inertiaY = _this.requestedCoordinates.y - newY;
      _this.requestedCoordinates = {
        x: roundedX,
        y: newY
      };
      if (_this.animationFrameRequested) {
        return;
      }
      _this.animationId = window.requestAnimationFrame(function () {
        if (!_this.isDown) {
          return;
        }
        if (_this.offsetCoords.x !== _this.requestedCoordinates.x) {
          _this.onMoveTo({
            x: _this.requestedCoordinates.x
          });
        }
        if (!_this.isTouch) {
          window.scroll({
            top: _this.requestedCoordinates.y
          });
        }
        _this.animationFrameRequested = false;
      });
      _this.animationFrameRequested = true;
    });
    _defineProperty(this, "onMouseUp", function () {
      if (!_this.isDown) {
        // listener is bound to window, so ignore unrelated event
        return;
      }
      _this.isDown = false;
      if (!_this.isDragging) {
        _this.startTarget = null;
        return;
      }

      // e.preventDefault doesn't cancel subsequbent click event for some reason, so
      // this elaborate solution is needed to prevent click event on program after dragging.
      // Mobile devices detect that the pointer has moved and will not trigger a click,
      // so only really needed for desktop.
      // Register listener for capture instead of the bubbling phase!
      _this.startTarget.addEventListener('click', captureClick, {
        capture: true
      });
      _this.startTarget = null;
      _this.isDragging = false;
      if (!_this.isTouch) {
        // add release inertia to scroll
        var direction = _this.inertiaY < 0 ? -1 : 1;
        _this.inertiaY = Math.min(Math.abs(_this.inertiaY), INERTIA_MAX) * direction;
        _this.animationId = window.requestAnimationFrame(_this.scrollInertia);
      }
    });
    _defineProperty(this, "scrollInertia", function () {
      if (Math.abs(_this.inertiaY) < INERTIA_MIN) {
        _this.inertiaY = 0;
      }
      if (_this.inertiaY === 0) {
        return;
      }
      var _this$requestedCoordi = _this.requestedCoordinates,
        x = _this$requestedCoordi.x,
        y = _this$requestedCoordi.y;
      _this.requestedCoordinates = {
        x: x,
        y: y - _this.inertiaY
      };
      window.scroll({
        top: _this.requestedCoordinates.y
      });
      _this.inertiaY /= FRICTION;
      _this.animationId = window.requestAnimationFrame(_this.scrollInertia);
    });
    this.horizontalTarget = _target;
    this.onMoveTo = onMoveTo;
    this.initialCoords = initialCoords;
    this.horizontalGridRatio = horizontalGridRatio;
    _target.addEventListener('mousedown', this.onMouseDown, {
      passive: true
    });
    _target.addEventListener('touchstart', this.onMouseDown, {
      passive: true
    });
    window.addEventListener('mousemove', this.onMouseMove, {
      passive: true
    });
    window.addEventListener('touchmove', this.onMouseMove, {
      passive: true
    });
    window.addEventListener('mouseup', this.onMouseUp, {
      passive: true
    });
    window.addEventListener('touchend', this.onMouseUp, {
      passive: true
    });
    document.body.addEventListener('selectstart', preventDefault, {
      passive: false
    });
  }
  _createClass(Draggable, [{
    key: "deinitialise",
    value: function deinitialise() {
      window.cancelAnimationFrame(this.animationId);
      document.body.removeEventListener('selectstart', preventDefault);
      this.horizontalTarget.removeEventListener('mousedown', this.onMouseDown);
      this.horizontalTarget.removeEventListener('touchstart', this.onMouseDown);
      window.removeEventListener('mousemove', this.onMouseMove);
      window.removeEventListener('touchmove', this.onMouseMove);
      window.removeEventListener('mouseup', this.onMouseUp);
      window.removeEventListener('touchend', this.onMouseUp);
    }
  }, {
    key: "setOffsetCoords",
    value: function setOffsetCoords(coords) {
      this.offsetCoords = coords;
    }
  }, {
    key: "setHorizontalGridRatio",
    value: function setHorizontalGridRatio(ratio) {
      this.horizontalGridRatio = ratio;
    }
  }]);
  return Draggable;
}();
exports.Draggable = Draggable;